import React, { useCallback } from 'react'
import { Form, FormRenderProps } from 'react-final-form'

import { Button, InputField } from 'Components/UI'
import validate from 'validate.js'

import { EMAIL_REGEX } from 'Constants/Regex'

import { StyledForm } from './styles'

enum Field {
  Email = 'email',
}

type Props = { onSubmit?: (value: FormValues) => void }

export type FormValues = { [Field.Email]: string }

const CONSTRAINTS = {
  [Field.Email]: {
    presence: {
      allowEmpty: false,
      message: `can't be blank`,
    },
    format: {
      pattern: new RegExp(EMAIL_REGEX),
      message: 'is not a valid',
    },
  },
}

function ProvideYourEmailForm({ onSubmit }: Props) {
  const formValidation = useCallback(
    (values: FormValues) => validate(values, CONSTRAINTS),
    [],
  )

  const renderForm = useCallback(
    ({ handleSubmit, submitting }: FormRenderProps<FormValues>) => (
      <StyledForm onSubmit={handleSubmit}>
        <InputField displayError label="Email" name={Field.Email} />

        <Button disabled={submitting} large mt={9} type="submit" width={1}>
          Continue
        </Button>
      </StyledForm>
    ),
    [],
  )

  const handleFormSubmit = useCallback(
    (values: FormValues) => {
      onSubmit?.(values)
    },
    [onSubmit],
  )

  return (
    <Form
      render={renderForm}
      validate={formValidation}
      onSubmit={handleFormSubmit}
    />
  )
}

export default ProvideYourEmailForm
